import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = ["href", "onClick"]
const _hoisted_3 = { key: 0 }
const _hoisted_4 = ["href", "onClick"]
const _hoisted_5 = {
  key: 0,
  class: "badge rounded-pill bg-danger"
}
const _hoisted_6 = {
  key: 1,
  class: "badge rounded-pill bg-primary"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "treebal2-pinned-white" }, null, -1)
const _hoisted_8 = { class: "item-info" }
const _hoisted_9 = ["title"]
const _hoisted_10 = { class: "item-actions dropdown dots" }
const _hoisted_11 = ["id"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "treebal-menu-vertical" }, null, -1)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = ["aria-labelledby"]
const _hoisted_15 = { key: 0 }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "treebal-edit" }, null, -1)
const _hoisted_17 = ["data-bs-target", "disabled", "onClick"]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "treebal-edit" }, null, -1)
const _hoisted_19 = { key: 1 }
const _hoisted_20 = ["data-bs-target", "onClick"]
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "treebal-trash" }, null, -1)
const _hoisted_22 = {
  key: 0,
  class: "item placeholder-glow"
}
const _hoisted_23 = /*#__PURE__*/_createStaticVNode("<div class=\"item-logo placeholder placeholder-lg col-1\"></div><div class=\"item-name placeholder placeholder-lg col-6\"></div><div class=\"item-info placeholder placeholder-lg col-1\"></div><div class=\"item-actions dropdown dots\"><button class=\"btn btn-neutral dropdown-toggle placeholder\" type=\"button\"></button></div>", 4)
const _hoisted_27 = [
  _hoisted_23
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_secured_image = _resolveComponent("secured-image")!
  const _component_router_link = _resolveComponent("router-link")!

  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["items selectable", {
      external: _ctx.externalMode,
    }])
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tribesContent, (tribe, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        class: _normalizeClass(["item", { 'have-action': false, selected: tribe.id === _ctx.tribeURLId }]),
        id: 'tribeItem-' + tribe.id
      }, [
        _createVNode(_component_router_link, {
          custom: "",
          to: {
          name: `${_ctx.modeRouteName}TribeInformationPublications`,
          params: { id: tribe.id },
        }
        }, {
          default: _withCtx(({ navigate, href }) => [
            _createElementVNode("div", {
              class: "item-logo",
              href: href,
              onClick: navigate
            }, [
              (!tribe.logo)
                ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(tribe.name?.substring(0, 2).toUpperCase() ?? ""), 1))
                : _createCommentVNode("", true),
              (tribe.logo !== undefined)
                ? (_openBlock(), _createBlock(_component_secured_image, {
                    key: 1,
                    src: tribe.logo
                  }, null, 8, ["src"]))
                : _createCommentVNode("", true)
            ], 8, _hoisted_2)
          ]),
          _: 2
        }, 1032, ["to"]),
        _createVNode(_component_router_link, {
          custom: "",
          to: {
          name: `${_ctx.modeRouteName}TribeInformationPublications`,
          params: { id: tribe.id },
        }
        }, {
          default: _withCtx(({ navigate, href }) => [
            _createElementVNode("div", {
              class: "item-name",
              href: href,
              onClick: navigate
            }, _toDisplayString(tribe.name ?? ""), 9, _hoisted_4)
          ]),
          _: 2
        }, 1032, ["to"]),
        (tribe.id && _ctx.getNotifications(tribe.id) > 0)
          ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.getNotifications(tribe.id)), 1))
          : _createCommentVNode("", true),
        (tribe.id && _ctx.getPinned(tribe.id) > 0)
          ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
              _createTextVNode(_toDisplayString(_ctx.getPinned(tribe.id)) + " ", 1),
              _hoisted_7
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("span", {
            class: _normalizeClass(["text-secondary", { 'treebal-anonymous': tribe.anonymous }])
          }, null, 2),
          _createElementVNode("span", {
            class: _normalizeClass(["treebal-megaphone-type-2 text-secondary", { 'treebal-anonymous': tribe.anonymous }]),
            title: _ctx.$t(`tribes.types.information`)
          }, null, 10, _hoisted_9)
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("button", {
            class: "btn btn-neutral dropdown-toggle",
            type: "button",
            "data-bs-toggle": "dropdown",
            "aria-expanded": "false",
            id: `${tribe.id}-actions`
          }, _hoisted_13, 8, _hoisted_11),
          _createElementVNode("ul", {
            class: "dropdown-menu",
            "aria-labelledby": `${tribe.id}-actions`
          }, [
            (_ctx.$can('update', 'TribeInformation'))
              ? (_openBlock(), _createElementBlock("li", _hoisted_15, [
                  (_ctx.$breakpoints.mobile)
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 0,
                        class: "dropdown-item",
                        to: {
                name: `${_ctx.modeRouteName}TribeInformationEdit`,
                params: { id: tribe.id },
              }
                      }, {
                        default: _withCtx(() => [
                          _hoisted_16,
                          _createTextVNode(" " + _toDisplayString(_ctx.$t(`global.edit`)), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"]))
                    : _createCommentVNode("", true),
                  (!_ctx.$breakpoints.mobile)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        type: "button",
                        class: "dropdown-item",
                        "data-bs-toggle": "modal",
                        "data-bs-target": `#${_ctx.mode}TribeFormSelector`,
                        disabled: !_ctx.$can('update', 'TribeInformation'),
                        onClick: ($event: any) => (_ctx.currentTribe = tribe)
                      }, [
                        _hoisted_18,
                        _createTextVNode(" " + _toDisplayString(_ctx.$t(`global.edit`)), 1)
                      ], 8, _hoisted_17))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (_ctx.$can('delete', 'TribeInformation'))
              ? (_openBlock(), _createElementBlock("li", _hoisted_19, [
                  _createElementVNode("button", {
                    class: "dropdown-item",
                    "data-bs-toggle": "modal",
                    "data-bs-target": `#${_ctx.mode}TribeDelete`,
                    onClick: ($event: any) => (_ctx.currentTribe = tribe)
                  }, [
                    _hoisted_21,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t(`global.delete`)), 1)
                  ], 8, _hoisted_20)
                ]))
              : _createCommentVNode("", true)
          ], 8, _hoisted_14)
        ])
      ], 10, _hoisted_1))
    }), 128)),
    (_ctx.tribes && _ctx.tribes.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_22, _hoisted_27))
      : _createCommentVNode("", true)
  ], 2)), [
    [_vShow, !_ctx.loading]
  ])
}